import {ApolloClient} from 'apollo-client';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {ApolloLink} from 'apollo-link';
import {createHttpLink} from 'apollo-link-http';
import {setContext} from 'apollo-link-context';
import {RetryLink} from 'apollo-link-retry';

const api = process.env.REACT_APP_BACKEND_URL;

function fragmentMapping(query, queryName, object) {
    let mapping;
    query.definitions.find(definition => {
        const queryFields = getFields(definition);
        mapping = fieldsQuery(queryFields, queryName);
        return mapping;

    });
    if (mapping) {
        return mapObject(mapping, object);
    }
}

function mapObject(mapping, object) {
    const IS_ARRAY = object instanceof Array;
    if (IS_ARRAY) {
        return object.map((item) => mapObject(mapping, item));
    }
    const mappedObject = {};

    mapping.forEach(item => {
        if (item.kind === 'Field') {
            const field = item.name.value;
            let value = object[field];
            value = value === undefined ? null : value;
            if (item.selectionSet)
                value = mapObject(getFields(item), value);
            mappedObject[field] = value;
        }
    });
    return mappedObject;
}


function fieldsQuery(selections, $query) {
    const selection = selections.find(item => {
        if (item.kind === 'Field') {
            const query = item.name.value;
            if (query === $query)
                return true;

        }
        return false;
    });
    return selection ? getFields(selection) : false;
}

function getFields(definition) {
    const {selectionSet} = definition;
    return selectionSet ? selectionSet.selections : [];
}

export {
    fragmentMapping
};

export default ({uri = `${api}/api/graphql`, authenticationService, logout, cookies}) => {
    // action which happens on relevant error
    const recoveryLink = new RetryLink({
        delay: {
            initial: 0,
        },
        attempts: {
            max: 2,
            retryIf: (error) => {
                if (error.statusCode === 401) {
                    return new Promise((resolve) => {
                        // your refresh query here
                        authenticationService.refreshAccessToken(cookies)
                            .then(() => {
                                resolve(true);
                            }).catch(() => {
                                logout();
                                resolve(false);
                            });
                    });
                }
                return false;
            }
        }
    });
    const authLink = setContext((_, {headers}) => {
        const token = authenticationService.getAccessToken(cookies);
        const accessPartner = authenticationService.getAccessPartner(cookies);
        // return the headers to the context so httpLink can read them
        return {
            headers: {
                ...headers,
                authorization: token ? `Bearer ${token}` : '',
                accessPartner,
            }
        };
    });
    const httpLink = createHttpLink({
        uri: uri,
    });
    return new ApolloClient({
        link: ApolloLink.from([
            recoveryLink,
            authLink,
            httpLink,
        ]),
        cache: new InMemoryCache()
    });
};
